/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowCRightIcon16Solid = forwardRef('ArrowCRightIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.11 2.622a1.25 1.25 0 0 1 1.768-.012l3.842 3.793a2.25 2.25 0 0 1 .01 3.193l-3.788 3.788a1.25 1.25 0 0 1-1.767-1.768l3.61-3.61L5.122 4.39a1.25 1.25 0 0 1-.012-1.768Z" })));
});
